import {defineRecipe} from '@chakra-ui/react3'

/**
 * recipe for Copy:
 * variants:
 *  - alignment: left | center | inherit
 *  - variant: default | hero
 */

export default defineRecipe({
    variants: {
        alignment: {
            left: {
                textAlign: 'flex-start'
            },
            center: {
                textAlign: 'center'
            }
        },
        variant: {
            default: {
                color: 'text.secondary',
                textStyle: 'body.medium'
            },
            hero: {
                color: 'text.primary',
                textStyle: 'body.large'
            },
            gallery: {
                color: {base: 'text.secondary', s: 'text.on-surface'},
                textStyle: 'body.small'
            }
        }
    },
    defaultVariants: {
        alignment: 'left',
        variant: 'default'
    }
})
